<template>
  <b-row
    :class="{'flex-row-reverse': isIdxOdd}"
    class="d-flex justify-content-between m-b-50"
  >
    <b-col cols="2">
      <img
        :src="item.imgSrc"
        alt="Fluid image"
      >
    </b-col>
    <b-col cols="10">
      <b-row align-h="end">
        <b-col cols="12">
          <p class="f-s-14 l-h-28 grey">
            <i class="i-b-open mr-1 pb-1" />
            {{ item.opinion }}
            <i class="i-b-close ml-1" />
          </p>
        </b-col>
      </b-row>
      <b-row
        :align-h="alignH"
      >
        <b-col
          md="5"
          sm="8"
        >
          <p class="text-primary text-primary-mulish font-weight-bold l-h-191-p grey mb-0">
            {{ item.fullName }}
          </p>
          <p class="text-primary text-primary-montserrat f-s-14 f-w-500 l-h-191-p grey">
            {{ item.position }}
          </p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'EmployeeItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
    idx: {
      type: Number,
      default: null,
    },
  },
  computed: {
    isIdxOdd() {
      return !!(this.idx % 2);
    },
    alignH() {
      return this.isIdxOdd ? 'start' : 'end';
    },
  },
};
</script>
